var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningTriangleOrange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 44 38.6",
    style: {
      enableBackground: "new 0 0 44 38.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E9531B;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9847",
    className: "st0",
    d: "M22,38.5c-6.6,0-13.1,0-19.7,0c-0.5,0-1.1-0.1-1.5-0.4c-0.8-0.6-1-1.7-0.4-2.6 C1.2,34,2,32.6,2.9,31.1c5.8-10,11.6-20,17.3-30c0.4-1,1.5-1.4,2.4-1c0,0,0.1,0,0.1,0.1c0.4,0.2,0.8,0.6,1,1 c2.8,4.8,5.6,9.7,8.4,14.5c3.7,6.5,7.5,12.9,11.2,19.4c0.8,0.8,0.8,2.1,0,2.9c-0.5,0.5-1.2,0.7-1.9,0.5C35,38.5,28.5,38.5,22,38.5z  M23.9,18.9c0-1.9,0-3.7,0-5.6c0.1-1-0.7-1.9-1.8-2c-1-0.1-1.9,0.7-2,1.8c0,0.1,0,0.1,0,0.2c0,0.8,0,1.6,0,2.4c0,2.9,0,5.8,0,8.7 c-0.1,0.7,0.3,1.4,0.9,1.8c0.9,0.6,2,0.3,2.6-0.6c0.2-0.3,0.3-0.7,0.3-1.1C23.9,22.6,23.9,20.7,23.9,18.9L23.9,18.9z M24.1,31 c0-1.2-0.9-2.2-2.1-2.2c0,0,0,0,0,0c-1.2,0-2.2,0.9-2.2,2.1c0,1.2,0.9,2.2,2.1,2.2C23.2,33.1,24.1,32.2,24.1,31z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTriangleOrange);
export default __webpack_public_path__ + "static/media/warning-triangle-orange.a6b57ea925b198be1ea55d03003793d6.svg";
export { ForwardRef as ReactComponent };